import { Input } from "antd";

import { RVFormFloatingLabelWrap } from "@regal-voice/ui";
import { generateFormItemRequiredRules } from "Components/FormItems/Shared/Validators/InputValidators/InputValidators";

import { EightByEightFormItemKeys } from "../constants";

import sharedStyles from "../SharedDemoStyles.module.scss";

const NAME_LABEL = "Campaign Name";
const ID_LABEL = "8x8 Campaign";
const ID_PLACEHOLDER = "8x8 Campaign Id";
const REQUIRED_NAME_RULE = generateFormItemRequiredRules("Campaign Name");
const REQUIRED_ID_RULE = generateFormItemRequiredRules("Campaign Id");

export function EightByEightFormItems(): JSX.Element {
    return (
        <>
            <RVFormFloatingLabelWrap
                className={sharedStyles.doubleItem}
                showFormLabel
                name={EightByEightFormItemKeys.campaignName}
                label={NAME_LABEL}
                rules={REQUIRED_NAME_RULE}
            >
                <Input />
            </RVFormFloatingLabelWrap>
            <RVFormFloatingLabelWrap
                className={sharedStyles.doubleItem}
                name={EightByEightFormItemKeys.campaignId}
                label={ID_LABEL}
                placeholder={ID_PLACEHOLDER}
                showFormLabel
                rules={REQUIRED_ID_RULE}
            >
                <Input />
            </RVFormFloatingLabelWrap>
        </>
    );
}
